export const mainConfiguration = {
  title: 'Precalculation Tool',
};
